import React, { useMemo, useState, useCallback, useRef } from 'react';
// eslint-disable-next-line import/extensions
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './styles.scss';
import cn from 'classnames';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// eslint-disable-next-line import/extensions
import 'swiper/css';

export const DateCarousel = ({ dateTimeEntries, selectedOccurrence, onClickOccurrence }) => {
  const swiperRef = useRef();
  const [isLeftButtonDisabled, setIsLeftButtonDisabled] = useState(true);
  const [isRightButtonDisabled, setIsRightButtonDisabled] = useState(false);

  const checkSwiperState = (swiper) => {
    if (swiper.isBeginning) {
      setIsLeftButtonDisabled(true);
      setIsRightButtonDisabled(false);
    }
    if (swiper.isEnd) {
      setIsLeftButtonDisabled(false);
      setIsRightButtonDisabled(true);
    }
    if (!swiper.isEnd && !swiper.isBeginning) {
      setIsLeftButtonDisabled(false);
      setIsRightButtonDisabled(false);
    }
  };

  const onBeforeInit = (swiper) => {
    swiperRef.current = swiper;
    checkSwiperState(swiper);
  };

  const handleOnTransitionSlide = useCallback((swiper) => {
    checkSwiperState(swiper);
  }, []);

  const handleLeftClick = useCallback(() => {
    if (swiperRef.current && !swiperRef.current.isBeginning) {
      swiperRef.current.slidePrev();
    }
  }, []);

  const handleRightClick = useCallback(() => {
    if (swiperRef.current && !swiperRef.current.isEnd) {
      swiperRef.current.slideNext();
    }
  }, []);

  const slides = useMemo(
    () =>
      dateTimeEntries.map((date) => (
        <SwiperSlide
          key={date.id}
          className={cn(styles.swiperSlide, { [styles.selected]: date.id === selectedOccurrence })}
          onClick={() => onClickOccurrence(date.id)}
        >
          <div className={styles.week}>{date.start.format('ddd')}</div>
          <div className={styles.day}>{date.start.format('D MMM')}</div>
        </SwiperSlide>
      )),
    [selectedOccurrence, dateTimeEntries, onClickOccurrence]
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.swiperContainer}>
        {!isLeftButtonDisabled && (
          <div className={styles.buttonLeft} onClick={handleLeftClick}>
            <ArrowBackIosIcon className={styles.icon} />
          </div>
        )}
        <Swiper
          spaceBetween={8}
          slidesPerView="auto"
          onTransitionStart={handleOnTransitionSlide}
          onBeforeInit={onBeforeInit}
          className={styles.dateTimeCarousel}
          touchRatio={1}
          simulateTouch
          allowTouchMove
          grabCursor
          breakpoints={{
            0: {
              slidesPerView: 3,
            },
            480: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 5,
            },
          }}
        >
          {slides}
        </Swiper>
        {!isRightButtonDisabled && (
          <div className={styles.buttonRight} onClick={handleRightClick}>
            <ArrowForwardIosIcon className={styles.icon} />
          </div>
        )}
      </div>
    </div>
  );
};
